// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Map from "../../../../../node_modules/rescript/lib/es6/map.js";
import * as Caml from "../../../../../node_modules/rescript/lib/es6/caml.js";
import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Caml_obj from "../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Caml_array from "../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Caml_format from "../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as MilestoneVM from "./MilestoneVM.bs.js";
import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as Caml_js_exceptions from "../../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function getTotalPoints(lst) {
  if (lst) {
    return lst.hd.points + getTotalPoints(lst.tl) | 0;
  } else {
    return 0;
  }
}

function getCycleAggrVM(rnrState) {
  var categoryAggVmList = List.map((function (rewardCategoryAgg) {
          return {
                  name: rewardCategoryAgg.name,
                  points: rewardCategoryAgg.points
                };
        }), rnrState.cycleCategoryAgg);
  var totalPoints = getTotalPoints(rnrState.cycleCategoryAgg);
  return {
          categoryAggList: categoryAggVmList,
          totalPoints: totalPoints
        };
}

var CycleAggrVM = {
  getTotalPoints: getTotalPoints,
  getCycleAggrVM: getCycleAggrVM
};

var compare = Caml_obj.caml_compare;

var DateMap = $$Map.Make({
      compare: compare
    });

function mergeRewardVMs(rwd1, rwd2, rwd3) {
  return List.sort((function (a, b) {
                return Caml_obj.caml_compare(b.date, a.date);
              }), List.filter(function (rewardVM) {
                    var match = List.length(rewardVM.rewards);
                    return match !== 0;
                  })(List.map((function (rewardVM) {
                        var rewards = List.filter(function (reward) {
                                var match = reward.totalPoints;
                                return match !== 0;
                              })(rewardVM.rewards);
                        return {
                                date: rewardVM.date,
                                rewards: rewards
                              };
                      }), List.map((function (param) {
                            var rvm = param[1];
                            var sorted_rewards = List.sort((function (a, b) {
                                    return Caml.caml_int_compare(a.orderPriority, b.orderPriority);
                                  }), rvm.rewards);
                            return {
                                    date: rvm.date,
                                    rewards: sorted_rewards
                                  };
                          }), Curry._1(DateMap.bindings, List.fold_left((function (dmap, rvm) {
                                    var d_rvm;
                                    try {
                                      d_rvm = Curry._2(DateMap.find, rvm.date, dmap);
                                    }
                                    catch (raw_exn){
                                      var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                                      if (exn.RE_EXN_ID === "Not_found") {
                                        return Curry._3(DateMap.add, rvm.date, rvm, dmap);
                                      }
                                      throw exn;
                                    }
                                    return Curry._3(DateMap.add, rvm.date, {
                                                date: rvm.date,
                                                rewards: List.append(rvm.rewards, d_rvm.rewards)
                                              }, dmap);
                                  }), DateMap.empty, List.concat({
                                      hd: rwd1,
                                      tl: {
                                        hd: rwd2,
                                        tl: {
                                          hd: rwd3,
                                          tl: /* [] */0
                                        }
                                      }
                                    })))))));
}

function getOrdersRegexMatch(message) {
  return Caml_option.null_to_opt(message.match(/(?:Five Star Trips )(\d*)(?: of )(\d*)/));
}

function getTotalQualifiedOrders(message) {
  var result = getOrdersRegexMatch(message);
  if (result !== undefined) {
    return Caml_format.caml_int_of_string(Caml_array.get(result, 1));
  } else {
    return 0;
  }
}

function getTotalCompletedOrders(message) {
  var result = getOrdersRegexMatch(message);
  if (result !== undefined) {
    return Caml_format.caml_int_of_string(Caml_array.get(result, 2));
  } else {
    return 0;
  }
}

function getRewardMessage(t_qualified_orders, t_orders) {
  return "Five Star Trips " + (String(t_qualified_orders) + (" of " + String(t_orders)));
}

function getMinExpiryTime(aggRdVM, rwd) {
  var date = DateTime$Catalyst.fromTimeStamp(rwd.expiryTime);
  if (Caml_obj.caml_greaterthan(aggRdVM.expiryTime, date)) {
    return date;
  } else {
    return aggRdVM.expiryTime;
  }
}

function getOrderRatingRewardAggr(orderRatingRewards, status) {
  return List.map((function (param) {
                var rewardDetailsVM = List.fold_left((function (aggRdVM, rwd) {
                        var totalQualifiedOrders = getTotalQualifiedOrders(aggRdVM.message);
                        var totalCompletedOrders = getTotalCompletedOrders(aggRdVM.message);
                        return {
                                name: aggRdVM.name,
                                totalPoints: aggRdVM.totalPoints + rwd.points | 0,
                                ids: List.append({
                                      hd: rwd.id,
                                      tl: /* [] */0
                                    }, aggRdVM.ids),
                                message: getRewardMessage(totalQualifiedOrders + rwd.qualifiedOrders | 0, totalCompletedOrders + rwd.completedOrders | 0),
                                status: status,
                                expiryTime: getMinExpiryTime(aggRdVM, rwd),
                                orderPriority: 1
                              };
                      }), {
                      name: /* CustomerService */0,
                      totalPoints: 0,
                      ids: /* [] */0,
                      message: getRewardMessage(0, 0),
                      status: status,
                      expiryTime: new Date("2050-04-27"),
                      orderPriority: 1
                    }, param[1]);
                return {
                        date: param[0],
                        rewards: {
                          hd: rewardDetailsVM,
                          tl: /* [] */0
                        }
                      };
              }), Curry._1(DateMap.bindings, List.fold_left((function (dmap, rwd) {
                        var rwds;
                        try {
                          rwds = Curry._2(DateMap.find, rwd.entitlementDate, dmap);
                        }
                        catch (raw_exn){
                          var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                          if (exn.RE_EXN_ID === "Not_found") {
                            return Curry._3(DateMap.add, rwd.entitlementDate, {
                                        hd: rwd,
                                        tl: /* [] */0
                                      }, dmap);
                          }
                          throw exn;
                        }
                        return Curry._3(DateMap.add, rwd.entitlementDate, List.append({
                                        hd: rwd,
                                        tl: /* [] */0
                                      }, rwds), dmap);
                      }), DateMap.empty, List.filter(function (rwd) {
                            return rwd.status === status;
                          })(orderRatingRewards))));
}

var OrderRatingRewardsAggrVM = {
  getOrdersRegexMatch: getOrdersRegexMatch,
  getTotalQualifiedOrders: getTotalQualifiedOrders,
  getTotalCompletedOrders: getTotalCompletedOrders,
  getRewardMessage: getRewardMessage,
  getMinExpiryTime: getMinExpiryTime,
  getOrderRatingRewardAggr: getOrderRatingRewardAggr
};

function getLoginHoursRegex(message) {
  return Caml_option.null_to_opt(message.match(/(?:Login Hours )(\d*)/));
}

function getLoginHours(message) {
  var result = getLoginHoursRegex(message);
  if (result !== undefined) {
    return Caml_format.caml_float_of_string(Caml_array.get(result, 1));
  } else {
    return 0.0;
  }
}

function getRewardMessage$1(hours) {
  return "Login Hours " + hours.toString();
}

function getMinExpiryTime$1(aggRdVM, rwd) {
  var date = DateTime$Catalyst.fromTimeStamp(rwd.expiryTime);
  if (Caml_obj.caml_greaterthan(aggRdVM.expiryTime, date)) {
    return date;
  } else {
    return aggRdVM.expiryTime;
  }
}

function getLoginHoursRatingRewardAggr(loginHourRewards, status) {
  return List.map((function (param) {
                var rewardDetailsVM = List.fold_left((function (aggRdVM, rwd) {
                        var totalHours = getLoginHours(aggRdVM.message);
                        return {
                                name: aggRdVM.name,
                                totalPoints: aggRdVM.totalPoints + rwd.points | 0,
                                ids: List.append({
                                      hd: rwd.id,
                                      tl: /* [] */0
                                    }, aggRdVM.ids),
                                message: "Login Hours " + (totalHours + rwd.loginHours).toString(),
                                status: status,
                                expiryTime: getMinExpiryTime$1(aggRdVM, rwd),
                                orderPriority: 2
                              };
                      }), {
                      name: /* LoginActivity */1,
                      totalPoints: 0,
                      ids: /* [] */0,
                      message: "Login Hours " + (0.0).toString(),
                      status: status,
                      expiryTime: new Date("2050-04-27"),
                      orderPriority: 2
                    }, param[1]);
                return {
                        date: param[0],
                        rewards: {
                          hd: rewardDetailsVM,
                          tl: /* [] */0
                        }
                      };
              }), Curry._1(DateMap.bindings, List.fold_left((function (dmap, rwd) {
                        var rwds;
                        try {
                          rwds = Curry._2(DateMap.find, rwd.entitlementDate, dmap);
                        }
                        catch (raw_exn){
                          var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                          if (exn.RE_EXN_ID === "Not_found") {
                            return Curry._3(DateMap.add, rwd.entitlementDate, {
                                        hd: rwd,
                                        tl: /* [] */0
                                      }, dmap);
                          }
                          throw exn;
                        }
                        return Curry._3(DateMap.add, rwd.entitlementDate, List.append({
                                        hd: rwd,
                                        tl: /* [] */0
                                      }, rwds), dmap);
                      }), DateMap.empty, List.filter(function (rwd) {
                            return rwd.status === status;
                          })(loginHourRewards))));
}

var LoginHoursRewardsAggrVM = {
  getLoginHoursRegex: getLoginHoursRegex,
  getLoginHours: getLoginHours,
  getRewardMessage: getRewardMessage$1,
  getMinExpiryTime: getMinExpiryTime$1,
  getLoginHoursRatingRewardAggr: getLoginHoursRatingRewardAggr
};

function getOrdersRegexMatch$1(message) {
  return Caml_option.null_to_opt(message.match(/(?:You completed )(\d*)(?: orders )/));
}

function getTotalCompletedOrders$1(message) {
  var result = getOrdersRegexMatch$1(message);
  if (result !== undefined) {
    return Caml_format.caml_int_of_string(Caml_array.get(result, 1));
  } else {
    return 0;
  }
}

function getTotalRequiredOrders(message) {
  var result = getOrdersRegexMatch$1(message);
  if (result !== undefined) {
    return Caml_format.caml_int_of_string(Caml_array.get(result, 2));
  } else {
    return 0;
  }
}

function getRewardMessage$2(t_completed_orders, t_required_orders) {
  return "You Completed " + (String(t_completed_orders) + (" out of " + (String(t_required_orders) + " orders ")));
}

function getMinExpiryTime$2(aggRdVM, rwd) {
  var date = DateTime$Catalyst.fromTimeStamp(rwd.expiryTime);
  if (Caml_obj.caml_greaterthan(aggRdVM.expiryTime, date)) {
    return date;
  } else {
    return aggRdVM.expiryTime;
  }
}

function getOrderFulfillmentRewardAggr(orderFulfillmentRewards, status) {
  return List.map((function (param) {
                var rewardDetailsVM = List.fold_left((function (aggRdVM, rwd) {
                        var totalRequiredOrders = getTotalRequiredOrders(aggRdVM.message);
                        var totalCompletedOrders = getTotalCompletedOrders$1(aggRdVM.message);
                        return {
                                name: aggRdVM.name,
                                totalPoints: aggRdVM.totalPoints + rwd.points | 0,
                                ids: List.append({
                                      hd: rwd.id,
                                      tl: /* [] */0
                                    }, aggRdVM.ids),
                                message: getRewardMessage$2(totalCompletedOrders + rwd.completedOrders | 0, totalRequiredOrders + (rwd.completedOrders + rwd.driverCancelledCount | 0) | 0),
                                status: status,
                                expiryTime: getMinExpiryTime$2(aggRdVM, rwd),
                                orderPriority: 3
                              };
                      }), {
                      name: /* OrderFulfillment */2,
                      totalPoints: 0,
                      ids: /* [] */0,
                      message: getRewardMessage$2(0, 0),
                      status: status,
                      expiryTime: new Date("2050-04-27"),
                      orderPriority: 3
                    }, param[1]);
                return {
                        date: param[0],
                        rewards: {
                          hd: rewardDetailsVM,
                          tl: /* [] */0
                        }
                      };
              }), Curry._1(DateMap.bindings, List.fold_left((function (dmap, rwd) {
                        var rwds;
                        try {
                          rwds = Curry._2(DateMap.find, rwd.entitlementDate, dmap);
                        }
                        catch (raw_exn){
                          var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                          if (exn.RE_EXN_ID === "Not_found") {
                            return Curry._3(DateMap.add, rwd.entitlementDate, {
                                        hd: rwd,
                                        tl: /* [] */0
                                      }, dmap);
                          }
                          throw exn;
                        }
                        return Curry._3(DateMap.add, rwd.entitlementDate, List.append({
                                        hd: rwd,
                                        tl: /* [] */0
                                      }, rwds), dmap);
                      }), DateMap.empty, List.filter(function (rwd) {
                            return rwd.status === status;
                          })(orderFulfillmentRewards))));
}

var OrderFulfillmentRewardsAggrVM = {
  getOrdersRegexMatch: getOrdersRegexMatch$1,
  getTotalCompletedOrders: getTotalCompletedOrders$1,
  getTotalRequiredOrders: getTotalRequiredOrders,
  getRewardMessage: getRewardMessage$2,
  getMinExpiryTime: getMinExpiryTime$2,
  getOrderFulfillmentRewardAggr: getOrderFulfillmentRewardAggr
};

function getClaimedRewardsVM(rnrState) {
  var claimedOrderRewardDateAggr = getOrderRatingRewardAggr(rnrState.dailyRewards.orderRatingRewards, /* Claimed */0);
  var claimedLoginRewardDateAggr = getLoginHoursRatingRewardAggr(rnrState.dailyRewards.loginHourRewards, /* Claimed */0);
  var claimedOrderFulfillmentDateAggr = getOrderFulfillmentRewardAggr(rnrState.dailyRewards.orderFulfillmentRewards, /* Claimed */0);
  return mergeRewardVMs(claimedOrderRewardDateAggr, claimedLoginRewardDateAggr, claimedOrderFulfillmentDateAggr);
}

function getUnclaimedRewardsVM(rnrState) {
  var unclaimedLoginRewardDateAggr = getLoginHoursRatingRewardAggr(rnrState.dailyRewards.loginHourRewards, /* Unclaimed */1);
  var unclaimedOrderRatingRewardDateAggr = getOrderRatingRewardAggr(rnrState.dailyRewards.orderRatingRewards, /* Unclaimed */1);
  var unclaimedOrderFulfillmentDateAggr = getOrderFulfillmentRewardAggr(rnrState.dailyRewards.orderFulfillmentRewards, /* Unclaimed */1);
  return mergeRewardVMs(unclaimedLoginRewardDateAggr, unclaimedOrderRatingRewardDateAggr, unclaimedOrderFulfillmentDateAggr);
}

var RewardsAggVM = {
  mergeRewardVMs: mergeRewardVMs,
  OrderRatingRewardsAggrVM: OrderRatingRewardsAggrVM,
  LoginHoursRewardsAggrVM: LoginHoursRewardsAggrVM,
  OrderFulfillmentRewardsAggrVM: OrderFulfillmentRewardsAggrVM,
  getClaimedRewardsVM: getClaimedRewardsVM,
  getUnclaimedRewardsVM: getUnclaimedRewardsVM
};

function getFlatComputers(rnrState) {
  return List.concat(List.map((function (rewardCategoryAgg) {
                    return rewardCategoryAgg.computers;
                  }), rnrState.cycleCategoryAgg));
}

function getOrderRatingComputer(computers) {
  var getComputer = List.find((function (computer) {
          switch (computer.TAG | 0) {
            case /* OrderRatingComputer */0 :
                return true;
            case /* LoginHourComputer */1 :
            case /* OrderFulfillmentComputer */2 :
                return false;
            
          }
        }), computers);
  switch (getComputer.TAG | 0) {
    case /* OrderRatingComputer */0 :
        return getComputer._0;
    case /* LoginHourComputer */1 :
    case /* OrderFulfillmentComputer */2 :
        return ErrorUtils$Catalyst.raiseError("RnrVMMapper.getOrderRatingComputer", "Unacceptable reward computer received", "");
    
  }
}

function getloginHourComputer(computers) {
  var getComputer = List.find((function (computer) {
          switch (computer.TAG | 0) {
            case /* LoginHourComputer */1 :
                return true;
            case /* OrderRatingComputer */0 :
            case /* OrderFulfillmentComputer */2 :
                return false;
            
          }
        }), computers);
  switch (getComputer.TAG | 0) {
    case /* LoginHourComputer */1 :
        var loginHourComputer = getComputer._0;
        return {
                computerType: loginHourComputer.computerType,
                windowStartMins: DateTime$Catalyst.toString("h:mm a", DateTime$Catalyst.getDateTimeAfterElapsedTime(loginHourComputer.windowStartMins, "minutes", new Date("1970-01-01:00:00"))),
                windowEndMins: DateTime$Catalyst.toString("h:mm a", DateTime$Catalyst.getDateTimeAfterElapsedTime(loginHourComputer.windowEndMins, "minutes", new Date("1970-01-01:00:00"))),
                perHourPoints: loginHourComputer.perHourPoints
              };
    case /* OrderRatingComputer */0 :
    case /* OrderFulfillmentComputer */2 :
        return ErrorUtils$Catalyst.raiseError("RnrVMMapper.getloginHourComputer", "Unacceptable reward computer received", "");
    
  }
}

function getOrderFulfillmentComputer(computers) {
  var getComputer = List.find((function (computer) {
          switch (computer.TAG | 0) {
            case /* OrderRatingComputer */0 :
            case /* LoginHourComputer */1 :
                return false;
            case /* OrderFulfillmentComputer */2 :
                return true;
            
          }
        }), computers);
  switch (getComputer.TAG | 0) {
    case /* OrderRatingComputer */0 :
    case /* LoginHourComputer */1 :
        return ErrorUtils$Catalyst.raiseError("RnrVMMapper.getOrderFulfillmentComputer", "Unacceptable reward computer received", "");
    case /* OrderFulfillmentComputer */2 :
        return getComputer._0;
    
  }
}

function getComputerDetails(rnrState) {
  return {
          orderRatingComputerDetails: getOrderRatingComputer(getFlatComputers(rnrState)),
          loginHourComputerDetails: getloginHourComputer(getFlatComputers(rnrState)),
          orderFulfillmentComputerDetails: getOrderFulfillmentComputer(getFlatComputers(rnrState))
        };
}

var ComputersVM = {
  getFlatComputers: getFlatComputers,
  getOrderRatingComputer: getOrderRatingComputer,
  getloginHourComputer: getloginHourComputer,
  getOrderFulfillmentComputer: getOrderFulfillmentComputer,
  getComputerDetails: getComputerDetails
};

function getViewModel(rnrState) {
  return {
          cycleAgg: getCycleAggrVM(rnrState),
          claimedRewards: getClaimedRewardsVM(rnrState),
          unclaimedRewards: getUnclaimedRewardsVM(rnrState),
          milestoneDetails: MilestoneVM.getMilestoneVM(rnrState),
          computerDetails: getComputerDetails(rnrState),
          vehicleCategory: rnrState.vehicleCategory
        };
}

export {
  CycleAggrVM ,
  DateMap ,
  RewardsAggVM ,
  ComputersVM ,
  getViewModel ,
  
}
/* DateMap Not a pure module */
